export default {
    data() {
        return {

            warningClass: function(items) { return items['info_ingresos/anulado'] == 1 ? true : false },
            tableGBSearch: ['info_ingresos/documento', 'info_ingresos/name'],

            tableGBoptions: {
                modals: [{
                        modal: "Editar",
                        icon: "pencil",
                        title: "Editar Registro",
                        variant: 'primary',
                        showFtn: function(value) {
                            if ((value['info_ingresos/anulado'] === 0 && value['info_afiliacion/id_list_novedad'] === 1 && value['autorizar'].length === 0) || (value['info_ingresos/anulado'] === 0 && value['info_ingresos/servicios'] === 2 && value['autorizar'].length === 0)) { return true }
                            return false;
                        },
                        movil: true
                    },
                    {
                        modal: "Anular",
                        icon: "x-circle",
                        title: "Anular Registro",
                        variant: 'danger',
                        showFtn: function(value) {
                            if ((value['info_ingresos/anulado'] === 0 && value['info_afiliacion/id_list_novedad'] === 1 && value['autorizar'].length === 0) || (value['info_ingresos/anulado'] === 0 && value['info_ingresos/servicios'] === 2 && value['autorizar'].length === 0)) { return true }
                            return false;
                        },
                        movil: true
                    },
                ]
            },

            tableGBItems: [{
                    thead: { th: 'Documento', sort: null, sortTable: 'info_ingresos/documento', movil: true },
                    tbody: { td: ['info_ingresos/documento', ] }
                },
                {
                    thead: { th: 'Nombre', sort: null, sortTable: 'info_ingresos/name', movil: true },
                    tbody: { td: ['info_ingresos/name'], }
                },
                {
                    thead: { th: 'Asesor', },
                    tbody: { td: ['datos_asesor/name'], ftn: function(value) { let name = value.split(' '); if (name.length > 1) { return name[0] + ' ' + name[1] } else { return name[0] } } }
                },
                {
                    thead: { th: 'Fecha', },
                    tbody: { td: ['info_ingresos/fecha'], }
                },
                {
                    thead: { th: 'Valor', },
                    tbody: { td: ['info_ingresos/valor'] }
                },
                {
                    thead: { th: 'Reporte', },
                    tbody: { td: ['info_ingresos/reporte'] }
                },
                {
                    thead: { th: 'Forma', },
                    tbody: { td: ['list_forma/name'] }
                },
                {
                    thead: { th: 'Cuenta', },
                    tbody: { td: ['list_cuentas/name', 'info_ingresos/consignacion'], show: { td: 'info_ingresos/id_list_forma', compare: 1, else: '' } }
                },
                {
                    thead: { th: 'Registro', },
                    tbody: { td: ['info_ingresos/id'], link: '/api/pdf/registro', show: { td: 'info_ingresos/anulado', compare: 0, else: 'Anulado' } }
                },
            ],

        }
    },
}